import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import CharityDirectory from './components/CharityDirectory';
Drupal.behaviors.charityDirectory = {
  attach: function attach(context) {
    var charityDirectories = context.querySelectorAll('[data-charity-directory]');
    charityDirectories.forEach(function (charityDirectory) {
      var root = createRoot(charityDirectory);
      var element = /*#__PURE__*/React.createElement(CharityDirectory, null); // <-- CMS values could be passed in through here too as props.
      root.render(element);
    });
  }
};